import { makeRequest } from 'utils/requestLogger';
// This is called when the student click "I did not speak"
export default (discussion_id, user_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${discussion_id}/not-speak-of-queue/${user_id}`
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/notSpeakOfQueue.js